import { render, staticRenderFns } from "./MencionesTwo.vue?vue&type=template&id=75befc60&scoped=true"
import script from "./MencionesTwo.vue?vue&type=script&lang=js"
export * from "./MencionesTwo.vue?vue&type=script&lang=js"
import style0 from "./MencionesTwo.vue?vue&type=style&index=0&id=75befc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75befc60",
  null
  
)

export default component.exports